import { InjectionToken } from '@angular/core';
import { LadeskChatAdditionalConfig } from '@bcf-vanilla-ui-ts-v1/shared/ladesk/ladesk-config.types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const LADESK_CHAT_ADDITIONAL_CONFIG: InjectionToken<LadeskChatAdditionalConfig> = new InjectionToken<string>(
  'LadeskChatAdditionalConfig'
);
